import React from 'react';
import { Link } from 'react-router-dom';

type BreadcrumbItem = {
  name: string;
  href: string;
  icon?: string;
};

type BreadcrumbsProps = {
  items: BreadcrumbItem[];
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <nav className="flex py-4 text-sm text-gray-700" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        {items.map((item, index) => (
          <li
            key={item.name + index}
            className="inline-flex items-center gap-[5px]"
          >
            <Link
              to={item.href}
              className={`inline-flex items-center ${
                index === 0 ? 'text-primary-red' : 'text-gray-700'
              } hover:text-primary-red`}
            >
              {item.name}
            </Link>
            {index < items.length - 1 && (
              <svg
                role="img"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_3765_17974)">
                  <path
                    d="M9.31002 6.71002C8.92002 7.10002 8.92002 7.73002 9.31002 8.12002L13.19 12L9.31002 15.88C8.92002 16.27 8.92002 16.9 9.31002 17.29C9.70002 17.68 10.33 17.68 10.72 17.29L15.31 12.7C15.7 12.31 15.7 11.68 15.31 11.29L10.72 6.70002C10.34 6.32002 9.70002 6.32002 9.31002 6.71002Z"
                    fill="#323232"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3765_17974">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
